import { Component, Input } from '@angular/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { AbstractComponent } from '../../components/abstract-component/abstract.component';
import { ListLoader } from '../../components/list-loader/list-loader';
import { AvBemerkungMasterDetailEntry, AvBemerkungVersionDetailEntry } from '../../../core/av-api';
import { TableSortModel } from '../../tablesort/tableSortModel';
import { ComparatorService } from '../../services/comparator-service';
import { ListLoaderWrapperComponent } from '../../components/list-loader-wrapper/list-loader-wrapper.component';
import { NgTemplateOutlet } from '@angular/common';
import { HistoryDirective } from '../../directives/history.directive';
import { KompaktTimepointComponent } from '../../kompaktdarstellung/timepoint/kompakt-timepoint.component';
import { TranslatePipe } from '@ngx-translate/core';
import { AvbemerkungArtPipe } from '../../pipes/simple/avbemerkung-art.pipe';
import ArtEnum = AvBemerkungVersionDetailEntry.ArtEnum;

@Component({
  selector: 'cap-avbemerkung-table',
  templateUrl: './avbemerkung-table.component.html',
  imports: [ListLoaderWrapperComponent, NgTemplateOutlet, HistoryDirective, KompaktTimepointComponent, TranslatePipe, AvbemerkungArtPipe]
})
export class AvbemerkungTableComponent extends AbstractComponent {
  @Input()
  hasRight = true;
  showTotal = false;
  showZeilenSelect = false;

  private _listLoader: ListLoader<AvBemerkungMasterDetailEntry>;
  private tableSortModel = new TableSortModel<AvBemerkungMasterDetailEntry>('table', this.comparatorService);

  constructor(private comparatorService: ComparatorService) {
    super();
    keysToTranslate<ArtEnum>(['NATURDENKMAL', 'LAGEFIXPUNKT', 'STREITIGE_GRENZE', 'EINGEDOLTES_GEWAESSER', 'ANDERE']);
    this.tableSortModel
      .addColumn('art', (a, b) => this.comparatorService.avBemerkungMasterDetailEntryComparator(a, b))
      .switchSortDirection();
  }

  @Input()
  set listLoader(listLoader: ListLoader<AvBemerkungMasterDetailEntry>) {
    if (!listLoader) {
      return;
    }
    this._listLoader = listLoader;
    this._listLoader.applySortModel(this.tableSortModel);
  }

  get listLoader(): ListLoader<AvBemerkungMasterDetailEntry> {
    return this._listLoader;
  }
}
